var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunityAvatar01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#DDF9E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.837 12L28.1627 12L33.1765 17.73H18.8508L13.837 12Z",
    fill: "#192245"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7059 17.6471H33.1765V30H18.7059V17.6471Z",
    fill: "#00C968"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82349 17.73L13.8372 12L18.851 17.73V29.9999L8.82349 30V17.73Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.062 24.282H26.3408V30H22.062V24.282Z",
    fill: "#006C52"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityAvatar01);
export default __webpack_public_path__ + "static/media/community-avatar-01.de8433b4.svg";
export { ForwardRef as ReactComponent };